var render, staticRenderFns
import script from "./TablesCard.vue?vue&type=script&lang=js"
export * from "./TablesCard.vue?vue&type=script&lang=js"
import style0 from "./TablesCard.vue?vue&type=style&index=0&id=8e7e05a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7e05a6",
  null
  
)

export default component.exports